<template>
  <v-row :class="rowClass" v-if="enabledExtraFilters.length">
    <v-col v-for="key in enabledExtraFilters" :key="key" :cols="cols" :class="colClass">
      <v-text-field
          v-if="definitions[key].type === 'text'"
          :value="filterSelection[key]?.text"
          :label="$t(definitions[key].label)"
          :ref="key"
          @input="(v) => onInput(v, key)"
          :class="{ 'to-upper-text': definitions[key].upperCase }"
          :prepend-inner-icon="definitions[key].icon"
          hide-details
          clearable
          dense
      />
      <v-menu
          v-else-if="definitions[key].type === 'date'"
          transition="scale-transition"
          offset-y
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="filterSelection[key]?.text"
              :label="$t(definitions[key].label)"
              :ref="key"
              v-bind="attrs"
              v-on="on"
              @click:clear="onDateInput(null, key)"
              :prepend-inner-icon="definitions[key].icon"
              hide-details
              clearable
              readonly
              dense
          />
        </template>
        <v-date-picker
            :value="filterSelection[key]?.value"
            @input="(v) => onDateInput(v, key)"
            color="primary"
        />
      </v-menu>
      <CustomAutocomplete
          v-else-if="definitions[key].type === 'select'"
          :ref="key"
          :current="filterSelection[key]"
          :value="'id'"
          :text="'name'"
          :label="$t(definitions[key].label)"
          :icon="definitions[key].icon"
          :textClass="textClass"
          :allowEmptySearch="true"
          @select="(v) => $emit('change', v, key, 'value', 'text')"
          @browse="(v) => browseSelectItems(v, key)"
      />
    </v-col>
    <v-col v-if="$scopedSlots.actions" :class="colClass" class="d-flex align-end justify-end">
      <slot name="actions" />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { EXTRA_FILTERS } from '@/helpers/extraFilters'
import CustomAutocomplete from '@/components/elements/CustomAutocomplete.vue'

export default {
  name: 'ExtraFilters',
  components: { CustomAutocomplete },
  emits: ['change'],
  props: {
    filterSelection: { type: Object, default: () => ({}) },
    rowClass: { type: String, default: 'ma-0' },
    colClass: { type: String, default: '' },
    cols: { type: [String, Number], default: undefined },
    textClass: { type: String, default: '' },
  },
  data() {
    return {
      definitions: EXTRA_FILTERS,
    }
  },
  computed: {
    ...mapGetters('account', ['enabledExtraFilters']),
  },
  methods: {
    browseSelectItems(search, key) {
      this.definitions[key].loadItems().then((names) => {
        const items = names
          .filter((name) => name.toUpperCase().includes(search.toUpperCase()))
          .map((name) => ({ id: name, name }))
        this.$refs[key][0].showList(items)
      })
    },
    onInput(value, key) {
      if (value && this.definitions[key].upperCase) value = value.toUpperCase()
      this.$emit('change', value, key, 'text', 'value')
    },
    onDateInput(value, key) {
      // value is the picked day as yyyy-mm-dd, sent as it is
      this.$emit('change', value, key, 'value', 'text')
    },
    reset() {
      this.enabledExtraFilters.forEach((key) => {
        const field = this.$refs[key]
        if (!field || !field[0]) return
        if (this.definitions[key].type === 'select') field[0].clearSelection()
        else field[0].reset()
      })
    },
  },
}
</script>

<style scoped>
.to-upper-text::v-deep input {
  text-transform: uppercase !important;
}
</style>
